<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="content">
    <div *ngIf="rows.length === 0" class="empty">(No fields)</div>

    <div *ngFor="let row of rows; trackBy: trackByKey" class="row">
        <div class="key">{{ row.key }}</div>
        <div class="value">{{ row.value }}</div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="doneClicked()">Done</button>
</mat-dialog-actions>
